import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowDownSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowDownSquare"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M15.5 13L12 16.5L8.5 13" stroke="currentColor" strokeLinecap="square"/><Path d="M12 7.5V16" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowDownSquare;
